<script lang="ts">
    import LinkList from "../LinkList.svelte"
    import MedialibImage from "../MedialibImage.svelte"

    export let introBox: BlockProductEyecatcherIntroBox
</script>

<article class="col-auto product-type col-grid grid-bleed gap-m">
    <!-- .product-type ist die Brand Row und bekommt andere CSS Stylings -->
    {#if introBox?.image}
        <div class="logo">
            <figure>
                <MedialibImage id="{introBox.image}" />
            </figure>
        </div>
    {/if}
    {#if introBox?.headline}
        <div class="headline">
            <h3>{introBox.headline}</h3>
        </div>
    {/if}
    {#if introBox?.text}
        <div class="col-auto text">
            {@html introBox.text}
        </div>
    {/if}
    {#if introBox?.links?.length}
        <div class="button-wrap tp-s">
            <LinkList links="{introBox.links}" />
        </div>
    {/if}
</article>
